export default "__VITE_ASSET__HJGr5pr2__"